export enum UserDetailsProperties {
  TimeStamp = 'TimeStamp',
  UserName = 'User Name',
  PartitionKey = 'Application Name',
  LoginLocation = 'Login Location',
  GatewayIp = 'Gateway IP',
  LocalIp = 'Local IP',
  IsValidUser = 'Is Nexus User',
  UserSamAccount = 'User Sam Account',
}
